export default __webpack_public_path__ + "static/media/location-active.82fabb9e.svg";